// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
/**
 * 发布回调记录 实体类
 * 发布回调记录
 */
export class PublishCallBackHistoryRecord extends BaseEntity {
  /** 总任务Id : 总任务Id */
  private _taskId: string;

  /** 设置：总任务Id */
  public get taskId() {
    return this._taskId;
  }

  /** 获取：总任务Id */
  public set taskId(value: string) {
    this._taskId = value;
  }

  /** 返回内容 : 返回内容 */
  private _content: string;

  /** 设置：返回内容 */
  public get content() {
    return this._content;
  }

  /** 获取：返回内容 */
  public set content(value: string) {
    this._content = value;
  }

  /** PipeLineId : 工作的流水线Id */
  private _pipeLineId: number;

  /** 设置：PipeLineId */
  public get pipeLineId() {
    return this._pipeLineId;
  }

  /** 获取：PipeLineId */
  public set pipeLineId(value: number) {
    this._pipeLineId = value;
  }

  /** 流水线次数编号 : 流水线次数编号 */
  private _builderNumber: number;

  /** 设置：流水线次数编号 */
  public get builderNumber() {
    return this._builderNumber;
  }

  /** 获取：流水线次数编号 */
  public set builderNumber(value: number) {
    this._builderNumber = value;
  }

  constructor() {
    super();
    this._taskId = '';
    this._content = '';
    this._pipeLineId = 0;
    this._builderNumber = 0;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: PublishCallBackHistoryRecord, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.taskId = element.taskId;
      this.content = element.content;
      this.pipeLineId = element.pipeLineId;
      this.builderNumber = element.builderNumber;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.taskId = json.TaskId;
    this.content = json.Content;
    this.pipeLineId = json.PipeLineId;
    this.builderNumber = json.BuilderNumber;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.TaskId = this.taskId;
    json.Content = this.content;
    json.PipeLineId = this.pipeLineId;
    json.BuilderNumber = this.builderNumber;
  }

  static Create(json: any): PublishCallBackHistoryRecord {
    const publishCallBackHistoryRecord = new PublishCallBackHistoryRecord();
    publishCallBackHistoryRecord.Deserialize(json);
    publishCallBackHistoryRecord.json = json;
    return publishCallBackHistoryRecord;
  }
}
